
import * as React from "react";
import { AlertTriangle } from "lucide-react";

interface Props {
    children?: React.ReactNode;
}

interface State {
    hasError: boolean;
    error: Error | null;
}

export class ErrorBoundary extends React.Component<Props, State> {
    public state: State = {
        hasError: false,
        error: null,
    };

    public static getDerivedStateFromError(error: Error): State {
        return { hasError: true, error };
    }

    public componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        console.error("Uncaught error:", error, errorInfo);
    }

    public render() {
        if (this.state.hasError) {
            return (
                <div className="flex flex-col items-center justify-center min-h-screen bg-[#121212] text-white p-4 font-sans">
                    <AlertTriangle size={48} className="text-red-500 mb-4" />
                    <h1 className="text-2xl font-bold mb-2">Something went wrong</h1>
                    <p className="text-gray-400 mb-4 text-center">
                        An error occurred while rendering the application.
                    </p>
                    <div className="bg-black/50 p-4 rounded text-sm text-red-300 w-full max-w-2xl overflow-auto border border-red-900/30">
                        <p className="font-bold mb-2">Error Details:</p>
                        <pre className="whitespace-pre-wrap font-mono text-xs">
                            {this.state.error?.message}
                            {this.state.error?.stack}
                        </pre>
                    </div>
                    <button
                        onClick={() => window.location.reload()}
                        className="mt-8 px-6 py-2 bg-blue-600 rounded hover:bg-blue-500 transition-colors font-bold text-sm"
                    >
                        Reload Application
                    </button>
                </div>
            );
        }

        return (this as any).props.children;
    }
}
